import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function StepNotes({ quote, update, settings }) {
    return (
        <div className="space-y-4" data-testid="step-notes">
            <Card className="rounded-xl border-slate-200 p-5 space-y-4">
                <div>
                    <div className="text-sm font-semibold text-slate-900">Customer-facing notes</div>
                    <div className="text-xs text-slate-500">Will appear on the customer's PDF and shareable view.</div>
                </div>
                <div>
                    <Label className="text-xs uppercase tracking-wide text-slate-500">Notes for the customer</Label>
                    <Textarea
                        rows={4}
                        value={quote.notes_customer || ""}
                        onChange={(e) => update({ notes_customer: e.target.value })}
                        placeholder="Thank you for considering Easy HomeSource…"
                        data-testid="step-notes-customer-textarea"
                    />
                </div>
                <div>
                    <Label className="text-xs uppercase tracking-wide text-slate-500">Next steps</Label>
                    <Textarea
                        rows={4}
                        value={quote.next_steps || ""}
                        onChange={(e) => update({ next_steps: e.target.value })}
                        placeholder={settings?.default_next_steps}
                        data-testid="step-notes-next-steps-textarea"
                    />
                    <div className="text-xs text-slate-500 mt-1">Leave blank to use the default from settings.</div>
                </div>
                <div>
                    <Label className="text-xs uppercase tracking-wide text-slate-500">Disclaimer</Label>
                    <Textarea
                        rows={4}
                        value={quote.disclaimer || ""}
                        onChange={(e) => update({ disclaimer: e.target.value })}
                        placeholder={settings?.default_disclaimer}
                        data-testid="step-notes-disclaimer-textarea"
                    />
                </div>
            </Card>

            <Card className="rounded-xl border-slate-200 p-5 space-y-4">
                <div>
                    <div className="text-sm font-semibold text-slate-900">Internal notes (associate-only)</div>
                    <div className="text-xs text-slate-500">Hidden from customer. Use for handoffs or reminders.</div>
                </div>
                <Textarea
                    rows={4}
                    value={quote.notes_internal || ""}
                    onChange={(e) => update({ notes_internal: e.target.value })}
                    placeholder="Internal notes…"
                    data-testid="step-notes-internal-textarea"
                />
            </Card>
        </div>
    );
}
